import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  getGraphPingServer5MinuteChannel = new Subject();
  getGraphPingServer30MinuteChannel = new Subject();
  getGraphPingServer1HourChannel = new Subject();
  getGraphPingServer6HourChannel = new Subject();
  getGraphPingServer1DayChannel = new Subject();
  getGraphPingServer1WeekChannel = new Subject();
  getGraphPingServer1WeekHistoryChannel = new Subject();
  getGraphPingServer1MonthChannel = new Subject();
  getGraphPingServer1MonthHistoryChannel = new Subject();
  getGraphPingServer6MonthChannel = new Subject();
  getGraphPingServer6MonthHistoryChannel = new Subject();
  //LAIN2
  getallHostChannel = new Subject();
  getAllPeriodChannel = new Subject();
  repository = new IndexRepository();

  constructor() {
    this.getGraphPingServer5MinuteChannel.next({ status: apiResponse.INITIAL });
    this.getGraphPingServer30MinuteChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1HourChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer6HourChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1DayChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1WeekChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1WeekHistoryChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1MonthChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer1MonthHistoryChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer6MonthChannel.next({
      status: apiResponse.INITIAL,
    });
    this.getGraphPingServer6MonthHistoryChannel.next({
      status: apiResponse.INITIAL,
    });
    //LAIN2
    this.getallHostChannel.next({ status: apiResponse.INITIAL });
    this.getAllPeriodChannel.next({ status: apiResponse.INITIAL });
  }
  fetchGraphPingServer5Minute = async (query) => {
    this.getGraphPingServer5MinuteChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchGraphPingServer5Minute(query)
        .then((result) => {
          this.getGraphPingServer5MinuteChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer5MinuteChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer30Minute = async (query) => {
    this.getGraphPingServer30MinuteChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer30Minute(query)
        .then((result) => {
          this.getGraphPingServer30MinuteChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer30MinuteChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1Hour = async (query) => {
    this.getGraphPingServer1HourChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1Hour(query)
        .then((result) => {
          this.getGraphPingServer1HourChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1HourChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer6Hour = async (query) => {
    this.getGraphPingServer6HourChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer6Hour(query)
        .then((result) => {
          this.getGraphPingServer6HourChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer6HourChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1Day = async (query) => {
    this.getGraphPingServer1DayChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1Day(query)
        .then((result) => {
          this.getGraphPingServer1DayChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1DayChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1Week = async (query) => {
    this.getGraphPingServer1WeekChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1Week(query)
        .then((result) => {
          this.getGraphPingServer1WeekChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1WeekChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1WeekHistory = async (query) => {
    this.getGraphPingServer1WeekHistoryChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1WeekHistory(query)
        .then((result) => {
          this.getGraphPingServer1WeekHistoryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1WeekHistoryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1Month = async (query) => {
    this.getGraphPingServer1MonthChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1Month(query)
        .then((result) => {
          this.getGraphPingServer1MonthChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1MonthChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer1MonthHistory = async (query) => {
    this.getGraphPingServer1MonthHistoryChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer1MonthHistory(query)
        .then((result) => {
          this.getGraphPingServer1MonthHistoryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer1MonthHistoryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer6Month = async (query) => {
    this.getGraphPingServer6MonthChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer6Month(query)
        .then((result) => {
          this.getGraphPingServer6MonthChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer6MonthChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchGraphPingServer6MonthHistory = async (query) => {
    this.getGraphPingServer6MonthHistoryChannel.next({
      status: apiResponse.LOADING,
    });
    try {
      await this.repository
        .fetchGraphPingServer6MonthHistory(query)
        .then((result) => {
          this.getGraphPingServer6MonthHistoryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getGraphPingServer6MonthHistoryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchAllHosts = async (query) => {
    this.getallHostChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAllHosts(query)
        .then((result) => {
          this.getallHostChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getallHostChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchAllPeriods = async (query) => {
    this.getAllPeriodChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAllPeriods(query)
        .then((result) => {
          this.getAllPeriodChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.getAllPeriodChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };
}

export default IndexBloc;
